import React, { PropsWithChildren, PropsWithRef, useContext, useEffect, useMemo } from 'react';

import { HTMLContainer } from './HtmlZone.style';
import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { TagService } from '../../utils/services/TagService';
import { InformationContext } from '../../utils/contexts/information.context';

export interface Props {
  html: string;
  dataTemplateConfig: string;
  className?: string;
  addEditableBlock?: (block: BlockInfoType) => void;
  displayName: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isEdition: boolean | undefined;
  testId?: string;
}

export const HtmlZone: React.FunctionComponent<PropsWithRef<Props>> = ({
  addEditableBlock,
  displayName,
  className,
  html,
  dataTemplateConfig,
  onClick,
  isEdition,
  testId,
} : PropsWithChildren<Props>) => {
  const dataTemplateType = 'html-zone';
  const { information } = useContext(InformationContext);

  const htmlWithTags = useMemo(() => {
    return addEditableBlock
      ? html
      : TagService.replaceTags(html, information);
  }, [addEditableBlock, html, information]);

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  return (
    <HTMLContainer
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-config-path={dataTemplateConfig}
      className={className}
      onClick={onClick}
      isEdition={isEdition}
      data-testid={testId}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlWithTags }} />
    </HTMLContainer>
  );
};
